import React from "react";
import { RouteNames } from "../../router";
import { Button } from "../../ui";
import { ImageModal, VideoPlayer } from "..";
import { SocialIconsList } from "../SocialIconsList";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import style from "./AboutProject.module.css";

export const AboutProject = ({ card }) => {
  const isDesktop = useMediaQuery("(min-width: 801px)");

  return (
    <div className={style.aboutProjectContainer}>
      <div className={style.aboutProjectInfo}>
        {isDesktop && (
          <Button text={"Back to portfolio"} path={RouteNames.PORTFOLIO} />
        )}
        <h1 className={style.aboutProjectTitle}>{card.title}</h1>
        <p className={style.aboutProjectText}>{card.text}</p>
        <div className={style.aboutProjectLine} />
        {isDesktop && <SocialIconsList fill="#3F4D63" />}
      </div>
      <div className={style.aboutProjectImageContainer}>
        <ImageModal
          img={card.img}
          alt={card.alt}
          title={card.title}
          text={card.text}
          aspectRatio="928 / 569"
        />
        <div className={style.aboutProjectImagesList}>
          {card.collection &&
            card.collection.map((item) => (
              <ImageModal
                key={item.id}
                img={item.img}
                alt={item.alt}
                title={item.title}
                text={item.text}
              />
            ))}
        </div>
        {card.video && (
          <div className={style.aboutProjectVideo}>
            <VideoPlayer
              height={isDesktop ? "450px" : "250px"}
              src={card.video}
            />
          </div>
        )}
        {!isDesktop && (
          <Button
            mt={"40px"}
            text={"Back to portfolio"}
            path={RouteNames.PORTFOLIO}
          />
        )}
      </div>
    </div>
  );
};
